var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getStatus && _vm.getProfile)?_c('UnauthorizedRedirect',{attrs:{"targetRoute":_vm.targetRoute}}):(_vm.getStatus)?_c('LoginRedirect'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }